module.exports = __webpack_public_path__ + "img/donation.7826c850.jpg";